import React from 'react';
import styled from '@emotion/styled';

const AutoIcon = styled.div`
	display: flex;
	width: 48px;
	justify-content: start;
	height: 24px;

	div {
		margin-right: 3px;
		width: 3px;
		height: 100%;
		background-color: currentColor;
	}
`;
export default () => (
	<AutoIcon data-testid="manual-spacing">
		<div />
		<div />
		<div />
	</AutoIcon>
);
